import Image from 'next/image'
import Box from '@mui/material/Box'
import Grid from '@mui/material/Grid'
import styled from '@emotion/styled'

import { HideInMobileGrid } from 'components/common/Hidden'
import LinkItem from './LinkItem'

const LinkImg = styled.img`
  ${({ theme }) => `
    height: 40px;
    width: 120px;
    ${theme.breakpoints.up('xl')} {
      width: 100%;
    }
  `}
`

const AppDownload = () => {
  return (
    <Box display="flex" flexDirection="column">
      <Grid container spacing={1}>
        <HideInMobileGrid item xs={12}>
          <Box
            display="flex"
            justifyContent={{ xs: 'left', xl: 'center' }}
            mb={4}
          >
            <Image
              src="/img/app_qrcode_new.svg"
              width={120}
              height={120}
              alt=""
            />
          </Box>
        </HideInMobileGrid>

        <Grid item xs={12} xl={6}>
          <LinkItem
            $isFirst
            href="https://apps.apple.com/tw/app/信義居家-清潔-搬家-裝潢-修繕服務/id1581712189"
            target="_blank"
          >
            <LinkImg src="/img/app_store.svg" alt="" />
          </LinkItem>
        </Grid>

        <Grid item xs={12} xl={6}>
          <LinkItem
            $isFirst
            href="https://play.google.com/store/apps/details?id=com.sinyi.living"
            target="_blank"
          >
            <LinkImg src="/img/google_play.svg" alt="" />
          </LinkItem>
        </Grid>
      </Grid>
    </Box>
  )
}

export default AppDownload
